import { render, staticRenderFns } from "./BimDemolitionCategory.vue.html?vue&type=template&id=6c6966a7&lang=html&external"
import script from "./BimDemolitionCategory.vue.js?vue&type=script&lang=js&external"
export * from "./BimDemolitionCategory.vue.js?vue&type=script&lang=js&external"
import style0 from "./BimDemolitionCategory.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports